/*
 * quick-add-bag.js
 * Collection grid only.
 *   1. Swaps the Add to bag label to "See N in bag" once in the cart.
 *   2. Tags the cart so the resulting order records which items were added
 *      from the collection grid rather than the product page.
 *
 * Standalone by design: registers no custom elements, so it cannot collide
 * with plp.js or pdp.js (both register product-form unguarded).
 */
(function () {
  'use strict';

  var GRID = '#ProductGridContainer';
  var BTN = '.quick-add__submit';
  var ATTR_LIST = '_quick_add_variants';
  var ATTR_FLAG = '_added_via';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var base = root.replace(/\/$/, '');
  var watched = new WeakSet();
  var pending = null;

  function variantIdOf(btn) {
    var form = btn.closest('form');
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function setState(btn, qty) {
    var span = btn.querySelector('span');
    if (!span) return;
    if (!btn.dataset.defaultLabel) btn.dataset.defaultLabel = span.textContent.trim();
    if (qty > 0) {
      btn.classList.add('is-in-bag');
      span.textContent = 'See ' + qty + ' in bag';
    } else {
      btn.classList.remove('is-in-bag');
      span.textContent = btn.dataset.defaultLabel;
    }
  }

  /* Record the variant against the cart. Persists onto the order as a
     note attribute, so it can be reported on later. */
  function tagCart(variantId, cart) {
    var attrs = (cart && cart.attributes) || {};
    var existing = String(attrs[ATTR_LIST] || '');
    var ids = existing ? existing.split(',') : [];
    if (ids.indexOf(String(variantId)) > -1) return;
    ids.push(String(variantId));

    var payload = { attributes: {} };
    payload.attributes[ATTR_LIST] = ids.join(',');
    payload.attributes[ATTR_FLAG] = 'Collection quick add';

    fetch(base + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).catch(function () { /* tagging is best-effort, never block the sale */ });

    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'quick_add_to_cart',
        add_location: 'collection_grid',
        variant_id: String(variantId)
      });
    }
  }

  function refresh() {
    var btns = document.querySelectorAll(GRID + ' ' + BTN);
    if (!btns.length) return;
    fetch(base + '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var qty = {};
        (cart.items || []).forEach(function (item) {
          var k = String(item.variant_id);
          qty[k] = (qty[k] || 0) + item.quantity;
        });

        /* Only tag when a click actually put the item in the cart - the
           loading class also clears on failure. */
        if (pending && qty[pending]) {
          tagCart(pending, cart);
        }
        pending = null;

        btns.forEach(function (btn) {
          if (btn.disabled) return;
          var v = variantIdOf(btn);
          setState(btn, v && qty[v] ? qty[v] : 0);
        });
      })
      .catch(function () { pending = null; });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest(GRID + ' ' + BTN);
      if (!btn) return;
      if (btn.classList.contains('is-in-bag')) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = base + '/cart';
        return;
      }
      pending = variantIdOf(btn);
    },
    true
  );

  function watch() {
    document.querySelectorAll(GRID + ' ' + BTN).forEach(function (btn) {
      if (watched.has(btn)) return;
      watched.add(btn);
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var was = String(records[i].oldValue || '');
          if (was.indexOf('loading') > -1 && !btn.classList.contains('loading')) {
            refresh();
            return;
          }
        }
      }).observe(btn, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
      });
    });
  }

  function init() { watch(); refresh(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    new MutationObserver(function () { watch(); refresh(); })
      .observe(container, { childList: true });
  });
})();
